//summary of everything
import React, { useState, useEffect } from 'react';
import { Container, Alert, Table, Button } from 'react-bootstrap';
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {apiUrl, apiPageLimit, reportEndDateDiff, reportStartDateDiff} from '../../../../util/Api';
import Paging from '../../../../components/Paging';

import { toFactDate, fromFactDate, toDisplayDate, alterDate, isFactDate, roundNum, toShortDateTimeDisplayFromStr } from '../../../../util/ChartUtils';
/*
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'

//import AnalyticsNav from '../../components/AnalyticsNav';
import LeftNav from '../../../components/LeftNav';
import GuardrailSummaryCharts from './components/GuardrailSummaryCharts'
*/

//const SENTIMENT_THRESHOLD = process.env.REACT_APP_SENTIMENT_THRESHOLD || 0.5;

const GuardrailLogs = () => {
    const [errors, setErrors] = useState([]);
    //const [account, setAccount] = useState(null);
    const [app, setApp] = useState(null);
    const [alert, setAlert] = useState(null);
    const [logs, setLogs] = useState([]);

    //const [range, setRange] = useState(null);

    //const [startDatePicker, setStartDatePicker] = useState(null);
    //const [endDatePicker, setEndDatePicker] = useState(null);
    //const [showPicker, setShowPicker] = useState(false);

    const [datesForLink, setDatesForLink] = useState('');
    const [recordCount, setRecordCount] = useState(0);
    const [searchParams] = useSearchParams();
    let alertId = searchParams.get('alertId');
    let typeId = searchParams.get('typeId');

    let navigate = useNavigate();
    let { accountKey, appKey, startFactDate, endFactDate } = useParams();

    //const currUserAccounts = useSelector(getUserAccounts);
    //const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
    //const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

    //let filters = (alertId ? `alertId=${alertId}` : '');
    let filters = '';
    if (alertId != null && alertId != "") {filters = `alertId=${alertId}`}
    if (typeId != null && typeId != "") {
        if(filters != "") {filters += "&"}
        filters += `typeId=${typeId}`
    }

    let page = searchParams.get('page') ? searchParams.get('page') : 1;
    let pageLimit = searchParams.get('limit') ? searchParams.get('limit') : apiPageLimit;
   
    /*
    const onDateChange = (dates) => {
        const [start, end] = dates;
        //console.log('dates:', dates);
        setStartDatePicker(start);
        setEndDatePicker(end);
        //setShowPicker(false);
        if (end !== null) {
            setShowPicker(false);
            navigate(`/account/${accountKey}/analytics/app/${appKey}/guardrails/${toFactDate(start)}/${toFactDate(end)}${filters != "" ? "?" + filters : ''}`);
        }
    }
    */

    useEffect(() => {

        let linkDates = "";
        if(startFactDate != null && startFactDate != ""){
            linkDates = `/${startFactDate}`;
            if(endFactDate != null && endFactDate != "") {
                linkDates += `/${endFactDate}`;
            }
            setDatesForLink(linkDates);
        }

        let startDate = new Date();
        let endDate = new Date();
        let startFact = startFactDate;
        let endFact = endFactDate;

        if (!isFactDate(endFact)) {
            //console.log('endFactDate is null')
            endDate.setDate(endDate.getDate() - reportEndDateDiff);
            endFact = toFactDate(endDate);
        } else {
            //console.log('endFactDate is not null', endFact)
            endDate = fromFactDate(endFact);
        }

        if (!isFactDate(startFact)) {
            //console.log('startFactDate is null')
            startDate.setDate(endDate.getDate() - reportStartDateDiff);
            startFact = toFactDate(startDate);
        } else {
            //console.log('startFactDate is not null', startFact)
            startDate = fromFactDate(startFact);
        }

        //setRange({ startDate: startFact, endDate: endFact });

        //document.title = "reconify guardrails";

        //setStartDatePicker(startDate);
        //setEndDatePicker(endDate);

        let options = {
            accountKey: accountKey,
            appKey: appKey,
            startDate: startFact,
            endDate: endFact,
            isActive:1,
            limit: pageLimit,
            limitStart: (pageLimit * (page-1))
        }
        if(alertId != null && alertId != ""){
            options.alertId = alertId;
        }
        if(typeId != null && typeId != ""){
            options.typeId = typeId;
        }
        
        let isAuthError = false;

        axios.post(apiUrl + '/guardrails/logs',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    //clear errors 
                    if(errors?.length > 0) {
                        setErrors([])
                    }
                    if (res.data.logs !== null) {
                        setLogs(res.data.logs);
                    }
                    if (res.data.app !== null) {
                        setApp(res.data.app);
                        //document.title = "reconify guardrails " + res.data.app.app;
                    }
                    if (res.data.alert !== null) {
                        setAlert(res.data.alert);
                    }
                    if (res.data.recordCount !== null) {
                        setRecordCount(res.data.recordCount);
                    }
                } else {
                    if(logs?.length > 0) {
                        setLogs([])
                    }
                    if (res.data.hasOwnProperty('app') && res.data.app !== null) {
                        setApp(res.data.app);
                        //document.title = "reconify guardrails " + res.data.app.app;
                    }
                    if (res.data.alert !== null) {
                        setAlert(res.data.alert);
                    }
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                redirectToLogin = true;
                                break;
                            case 'no-app':
                            case 'no-valid-app':
                                //console.log('no results')
                                errorMsgs.push('There was no matching app.');
                                break;
                            case 'no-results':
                                //console.log('no results')
                                errorMsgs.push('There were no matching logs for this date range.');
                                break;
                            default:
                                //TODO: may want to just ignore - no sense showing anything?
                                errorMsgs.push('There was an error retrieving reports.');
                        }
                    });
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    }
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {

            });
    }, [accountKey, appKey, navigate, page, pageLimit, startFactDate, endFactDate, alertId])

    const sortByDate = () => {
        let temp = [...logs]
        temp.sort((a,b) => (a.created < b.created) ? -1 : 1)
        setLogs(temp);
    }
    const sortByTag = () => {
        let temp = [...logs]
        temp.sort((a,b) => (a.tag < b.tag) ? -1 : 1)
        setLogs(temp);
    }
    const sortByAlert = () => {
        let temp = [...logs]
        temp.sort((a,b) => (a.alertId < b.alertId) ? -1 : 1)
        setLogs(temp);
    }
    const sortByType = () => {
        let temp = [...logs]
        temp.sort((a,b) => (a.typeId < b.typeId) ? -1 : 1)
        setLogs(temp);
    }
    const sortByScore = () => {
        let temp = [...logs]
        temp.sort((a,b) => (a.score < b.score) ? -1 : 1)
        setLogs(temp);
    }
    const sortByMatched = () => {
        let temp = [...logs]
        temp.sort((a,b) => (a.matched < b.matched) ? -1 : 1)
        setLogs(temp);
    }

    return (
            <div>   
                {
                    errors.length > 0 ? (
                        <Alert variant='danger'>
                            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                        </Alert>
                    ) : (null)
                }
                {
                    logs.length > 0 ? (
                        <>
                            <h4>Guardrail Alerts</h4>
                            <div className='chart-card'>
                            <Table  borderless size='sm' responsive>
                                <thead>
                                    <tr>
                                        <th><span onClick={sortByDate} role="button">Date</span></th>
                                        <th ><span onClick={sortByTag} role="button">Tag</span></th>
                                        <th ><span onClick={sortByType} role="button">Type</span></th>
                                        <th ><span onClick={sortByMatched} role="button">Text</span></th>
                                        <th className='text-end'><span onClick={sortByScore} role="button">Score</span></th>
                                        <th >action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        logs.map((log, i) => (
                                            <tr key={'log.' + i}>
                                                {/*<td className='nowrap'>{new Date(log.created).toLocaleDateString()}</td>*/}
                                                <td >{toShortDateTimeDisplayFromStr(log.created)}</td>
                                                <td ><Link to={`/account/${accountKey}/guardrails/app/${appKey}/detail/${log.alertId}`}>{log.tag}</Link></td>
                                                <td >{log.typeId == 1 ? 'Prompt' : 'Response'}</td>
                                                <td ><span className={`chat-bubble ${log.typeId == 1 ? 'chat-bubble-in' : 'chat-bubble-out'}`}>{log.matched}</span></td>
                                                <td className='text-end'>{roundNum(log.score, 3)}</td>
                                                <td ><Link to={`/account/${accountKey}/analytics/app/${app.appKey}/interaction/${log.interactionId}${datesForLink}`} className='btn btn-theme btn-sm'>view</Link></td>

                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                            </div>
                            <Paging base={`/account/${accountKey}/analytics/app/${appKey}/guardrails${datesForLink}`} page={page} limit={pageLimit} total={recordCount}  classStyles='my-3' additional={filters}/>
                        </>
                    ) : (
                        null
                    )
                }
            </div>
    )
}

export default GuardrailLogs